import app from 'flarum/forum/app';
export default async function loadRegistrationChallenge() {
  const response = await app.request({
    method: 'GET',
    url: `${app.forum.attribute('apiUrl')}/devconnect/security/registration-challenge`
  });
  return response?.data?.attributes?.token || '';
}
flarum.reg.add('devconnect-security', 'forum/service/registrationChallenge', loadRegistrationChallenge);
flarum.reg.add('devconnect-security', 'forum/service/registrationChallenge', loadRegistrationChallenge);